module.exports = __webpack_public_path__ + "static/ic_activity@2x.cc68fe1e.png";